<template id="report-master">
    <section>
        <b-alert
                :show="dismissCountDown"
                dismissible
                variant="Success"
                @dismissed="dismissCountDown=0">
            Record Saved Successfully
        </b-alert>
        <b-alert
                :show="dismissCountDownUpdated"
                dismissible
                variant="Warning"
                @dismissed="dismissCountDown=0">
            Record Updated Successfully
        </b-alert>
        <div class="row">
            <div class="col-md-10 col-lg-12 text-center mt-3 mb-5 ml-2">
                <div class="card">
                    <div class="card-header text-left">
                        <i class="fa fa-searchengin"></i>
                        Report Master Screen
                    </div>
                    <div class="card-body">
                        <!--Filters-->
                        <!--table-->
                        <div class="table-responsive">
                            <table class="table table-bordered">
                                <thead class="thead-dark">
                                <tr class="text-center">
                                    <th>Menu ID</th>
                                    <th>Report Name</th>
                                    <th>Report Metadata Row</th>
                                    <th>RM1</th>
                                    <th>RM2</th>
                                    <th>RM3</th>
                                    <th>RM4</th>
                                    <th>RM5</th>
                                    <th>RD1L1 Name</th>
                                    <th>RD1L2 Name</th>
                                    <th>RD1L3 ID</th>
                                    <th>RD1L3 Name</th>
                                    <th>RD2 ID</th>
                                    <th>RD2 Name</th>
                                    <th>RD3 Name</th>
                                    <th>L1 Data Source SQL</th>
                                    <th>L2 Data Source SQL</th>
                                    <th>L3 Data Source SQL</th>
                                    <th>Visible Flag</th>
                                    <th>Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-for="(x,idx) in reportMasterData" @click="toggle(x.syspk)"
                                          :class="{ opened: opened.includes(x.syspk) }">
                                    <tr :value="x" v-bind:key="idx">
                                        <td>
                                            <span class="color">{{x.menuId}}</span><br>
                                        </td>
                                        <td>
                                            <span class="color">{{x.reportName}}</span><br>
                                        </td>
                                        <td>
                                            <span class="color">{{x.reportMetadataRow}}</span><br>
                                        </td>
                                        <td>
                                            <span class="color">{{x.rm1}}</span><br>
                                        </td>
                                        <td>
                                            <span class="color">{{x.rm2}}</span><br>
                                        </td>
                                        <td>
                                            <span class="color">{{x.rm3}}</span><br>
                                        </td>
                                        <td>
                                            <span class="color">{{x.rm4}}</span><br>
                                        </td>
                                        <td>
                                            <span class="color">{{x.rm5}}</span><br>
                                        </td>
                                        <td>
                                            <span class="color">{{x.rd1l1_name}}</span><br>
                                        </td>
                                        <td>
                                            <span class="color">{{x.rd1l2_name}}</span><br>
                                        </td>
                                        <td>
                                            <span class="color">{{x.rd1l3_id}}</span><br>
                                        </td>
                                        <td>
                                            <span class="color">{{x.rd1l3_name}}</span><br>
                                        </td>
                                        <td>
                                            <span class="color">{{x.rd2_id}}</span><br>
                                        </td>
                                        <td>
                                            <span class="color">{{x.rd2_name}}</span><br>
                                        </td>
                                        <td>
                                            <span class="color">{{x.rd3_name}}</span><br>
                                        </td>
                                        <td>
                                            <span class="color">{{x.l1_dataSourceSql}}</span><br>
                                        </td>
                                        <td>
                                            <span class="color">{{x.l2_dataSourceSql}}</span><br>
                                        </td>
                                        <td>
                                            <span class="color">{{x.l3_dataSourceSql}}</span><br>
                                        </td>
                                        <td>
                                            <span class="color">{{x.visibleFlag}}</span><br>
                                        </td>
                                        <td class="text-center">
                                            <div class="btn-group">
                                                <button class="btn btn-sm btn-outline-primary" v-b-tooltip.hover
                                                        title="Add"
                                                        v-on:click="showRow(x.syspk)">
                                                    <i class="fa fa-plus"></i>
                                                </button>
                                                <button class="btn btn-sm btn-outline-warning" size="sm"
                                                        v-b-tooltip.hover
                                                        title="Edit" v-on:click="edit(x.syspk)">
                                                    <i class="fa fa-edit"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <template v-if="showInputfield && x.syspk == editableId">
                                        <tr :key="x.idx"><h6>Edit Record</h6></tr>
                                        <tr :key="x.idx" style="background-color: #FFF9DF;font-size: 12px">
                                            <td>
                                                <label>Menu ID</label>
                                                <input type="text"
                                                       v-model="x.menuId"
                                                       class="form-control" :disabled="true">
                                            </td>
                                            <td>
                                                <label>Report Name</label>
                                                <input type="text"
                                                       v-model="x.reportName"
                                                       class="form-control" :disabled="true">
                                            </td>
                                            <td>
                                                <label>Report Metadata Row</label>
                                                <input type="text"
                                                       v-model="x.reportMasterData"
                                                       class="form-control" :disabled="true">
                                            </td>
                                            <td>
                                                <label>RM1</label>
                                                <input type="text"
                                                       v-model="x.rm1"
                                                       class="form-control" :disabled="true">
                                            </td>
                                            <td>
                                                <label>RM2</label>
                                                <input type="text"
                                                       v-model="x.rm2"
                                                       class="form-control" :disabled="true">
                                            </td>
                                            <td>
                                                <label>RM3</label>
                                                <input type="text"
                                                       v-model="x.rm3"
                                                       class="form-control" :disabled="true">
                                            </td>
                                            <td>
                                                <label>RM4</label>
                                                <input type="text"
                                                       v-model="x.rm4"
                                                       class="form-control" :disabled="true">
                                            </td>
                                            <td>
                                                <label>RM5</label>
                                                <input type="text"
                                                       v-model="x.rm5"
                                                       class="form-control" :disabled="true">
                                            </td>
                                            <td>
                                                <label>RD1L1 Name</label>
                                                <input type="text"
                                                       v-model="x.rd1l1_name"
                                                       class="form-control" :disabled="true">
                                            </td>
                                            <td>
                                                <label>RD1L2 Name</label>
                                                <input type="text"
                                                       v-model="x.rd1l2_name"
                                                       class="form-control" :disabled="true">
                                            </td>
                                            <td>
                                                <label>RD1L3 ID</label>
                                                <input type="text"
                                                       v-model="x.rd1l3_id"
                                                       class="form-control" :disabled="true">
                                            </td>
                                            <td>
                                                <label>RD1L3 Name</label>
                                                <input type="text"
                                                       v-model="x.rd1l3_name"
                                                       class="form-control" :disabled="true">
                                            </td>
                                            <td>
                                                <label>RD2 ID</label>
                                                <input type="text"
                                                       v-model="x.rd2_id"
                                                       class="form-control" :disabled="true">
                                            </td>
                                            <td>
                                                <label>RD2 Name</label>
                                                <input type="text"
                                                       v-model="x.rd2_name"
                                                       class="form-control" :disabled="true">
                                            </td>
                                            <td>
                                                <label>RD3 Name</label>
                                                <input type="text"
                                                       v-model="x.rd3_name"
                                                       class="form-control" :disabled="true">
                                            </td>
                                            <td>
                                                <label>L1 Data Source SQL</label>
                                                <input type="text"
                                                       v-model="x.l1_dataSourceSql"
                                                       class="form-control" :disabled="true">
                                            </td>
                                            <td>
                                                <label>L2 Data Source SQL</label>
                                                <input type="text"
                                                       v-model="x.l2_dataSourceSql"
                                                       class="form-control" :disabled="true">
                                            </td>
                                            <td>
                                                <label>L3 Data Source SQL</label>
                                                <input type="text"
                                                       v-model="x.l3_dataSourceSql"
                                                       class="form-control" :disabled="true">
                                            </td>
                                            <td>
                                                <label>Visible Flag</label>
                                                <input type="text"
                                                       v-model="x.visibleFlag"
                                                       class="form-control" :disabled="true">
                                            </td>
                                            <td class="text-center">
                                                <button class="btn btn-sm btn-outline-primary"
                                                        v-on:click="updateReportMaster(x)"
                                                        v-b-tooltip.hover
                                                        title="Save">
                                                    <i class="fa fa-save"></i>
                                                </button>
                                                <button class="btn btn-sm btn-danger" v-on:click="hideR(e,x)"
                                                        v-b-tooltip.hover
                                                        title="Cancel">
                                                    <i class="fa fa-window-minimize"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-if="showInput && x.syspk == savetableId">
                                        <tr :key="x.idx"><h6>New Record</h6></tr>
                                        <tr :key="x.idx" style="background-color: #FFF9DF;font-size: 12px">
                                            <td>
                                                <label>Menu ID</label>
                                                <input type="text"
                                                       v-model="e.menuId"
                                                       class="form-control">
                                            </td>
                                            <td>
                                                <label>Report Name</label>
                                                <input type="text"
                                                       v-model="e.reportName"
                                                       class="form-control">
                                            </td>
                                            <td>
                                                <label>Report Metadata Row</label>
                                                <input type="text"
                                                       v-model="e.reportMetadataRow"
                                                       class="form-control">
                                            </td>
                                            <td>
                                                <label>RM1</label>
                                                <input type="text"
                                                       v-model="e.rm1"
                                                       class="form-control">
                                            </td>
                                            <td>
                                                <label>RM2</label>
                                                <input type="text"
                                                       v-model="e.rm2"
                                                       class="form-control">
                                            </td>
                                            <td>
                                                <label>RM3</label>
                                                <input type="text"
                                                       v-model="e.rm3"
                                                       class="form-control">
                                            </td>
                                            <td>
                                                <label>RM4</label>
                                                <input type="text"
                                                       v-model="e.rm4"
                                                       class="form-control">
                                            </td>
                                            <td>
                                                <label>RM5</label>
                                                <input type="text"
                                                       v-model="e.rm5"
                                                       class="form-control">
                                            </td>
                                            <td>
                                                <label>RD1L1 Name</label>
                                                <input type="text"
                                                       v-model="e.rd1l1_name"
                                                       class="form-control">
                                            </td>
                                            <td>
                                                <label>RD1L2 Name</label>
                                                <input type="text"
                                                       v-model="e.rd1l2_name"
                                                       class="form-control">
                                            </td>
                                            <td>
                                                <label>RD1L3 ID</label>
                                                <input type="text"
                                                       v-model="e.rd1l3_id"
                                                       class="form-control">
                                            </td>
                                            <td>
                                                <label>RD1L3 Name</label>
                                                <input type="text"
                                                       v-model="e.rd1l3_name"
                                                       class="form-control">
                                            </td>
                                            <td>
                                                <label>RD2 ID</label>
                                                <input type="text"
                                                       v-model="e.rd2_id"
                                                       class="form-control">
                                            </td>
                                            <td>
                                                <label>RD2 Name</label>
                                                <input type="text"
                                                       v-model="e.rd2_name"
                                                       class="form-control">
                                            </td>
                                            <td>
                                                <label>RD3 Name</label>
                                                <input type="text"
                                                       v-model="e.rd3_name"
                                                       class="form-control">
                                            </td>
                                            <td>
                                                <label>L1 Data Source SQL</label>
                                                <input type="text"
                                                       v-model="e.l1_dataSourceSql"
                                                       class="form-control">
                                            </td>
                                            <td>
                                                <label>L2 Data Source SQL</label>
                                                <input type="text"
                                                       v-model="e.l2_dataSourceSql"
                                                       class="form-control">
                                            </td>
                                            <td>
                                                <label>L3 Data Source SQL</label>
                                                <input type="text"
                                                       v-model="e.l3_dataSourceSql"
                                                       class="form-control">
                                            </td>
                                            <td>
                                                <label>Visible Flag</label>
                                                <input type="text"
                                                       v-model="e.visibleFlag"
                                                       class="form-control">
                                            </td>
                                            <td class="text-center">
                                                <b-button v-on:click="saveReportMaster(e)" variant="outline-primary"
                                                          size="sm"
                                                          v-b-tooltip.hover
                                                          title="Save">
                                                    <i class="fa fa-save"></i>
                                                </b-button>
                                                <b-button v-on:click="hideR(e)" variant="outline-danger" size="sm"
                                                          v-b-tooltip.hover
                                                          title="Cancel">
                                                    <i class="fa fa-window-minimize"></i>
                                                </b-button>
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from 'axios'

export default {

        name: 'report-master',
        data: function () {
            return {
                reportMasterData: [],
                e: [],
                showInput: '',
                showInputfield: '',
                options: [],
                editableId: [],
                dismissSecs: 1,
                dismissCountDown: 0,
                dismissCountDownUpdated: 0,
                flag: ['True', 'False'],
                options2: [],
                opened: [],
                savetableId: [],
                hideRow: [],
            }
        },

        created: function () {
            this.loadReportMaster()
        },
        methods: {
            //Get Request
            loadReportMaster: function () {
               console.log('rr','load state');  this.$store.dispatch("loadState").then(() => {
                    this.reportMasterData = this.$store.state.reportMaster
                    console.log("All fw report master data", this.reportMasterData)
                }, err => {
                    console.log('Error in fetching Record', err)
                })
            },
            //Post Request
            saveReportMaster: function (e) {
                console.log("Test save record",this.e.menuId)
                let payload = Object.assign({}, e)
                axios.post('/api/reportmaster', payload)
                    .then(this.loadReportMaster(), e => {
                        console.error('error in Saving Record', e)
                    })
                this.dismissCountDown = this.dismissSecs
                this.savetableId = null
            }
            ,

            //Put/Update Request
            updateReportMaster: function (x) {
                console.log('Testing update request', this.x)
                axios.put('/api/dashboard_screen/reportmaster', x)
                    .then(response => {
                        console.log('Data Updated successfully', response)
                    })
                    .then(this.loadReportMaster(), e => {
                        console.error('error in Updating Record', e)
                    })
                this.dismissCountDownUpdated = this.dismissSecs
                this.editableId = null
            }
            ,

            //Show Edit Input Field
            edit: function (syspk, x) {
                console.log('Entered into edit function', x)
                this.showInputfield = true
                this.editableId = syspk
            }
            ,

            //Show Row
            showRow: function (syspk) {
                this.showInput = true
                this.savetableId = syspk

            }
            ,
            //High Light Selected Row
            toggle(syspk) {
                /* const index = this.opened.indexOf(id)*/
                this.opened.push(syspk)
            }
            ,
            show: function () {
                this.$modal.show('hello-world')
            }
            ,
            hide: function () {
                this.$modal.hide('hello-world')
            }
            ,

            //Hide Add record or save record
            hideR: function (syspk) {
                if (this.savetableId == syspk) {
                    this.savetableId = null
                    this.editableId = null
                } else {
                    this.savetableId = syspk
                    this.editableId = syspk
                }
            }
        },//Method End

    }
</script>
<style>
    .opened {
        background-color: #EBEBEB;
    }

    .t-scroll {
        display: inline-block;
        height: 260px;
        overflow-y: scroll;
    }

    .font {
        /*color: #0b58a2;*/
    }

    .color {
        font-weight: bold;
        color: dimgrey;
    }

    /*Hide up/down arrowin input fields*/
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    .table {
        font-size: 12px;
        text-align: left;
    }

    .table tr, .table td {
        height: 3px;
    }

    /*To Increase or Decrease Row Height change the padding value*/
    .table > tbody > tr > td, .table > tbody > tr > th, .table > tfoot > tr > td, .table > tfoot > tr > th, .table > thead > tr > td, .table > thead > tr > th {
        padding: 2px;
    }
</style>




